import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconTrendingUp: React.FC<IconProps> = ({ ...props }) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7922 6H16.1297C15.7406 6 15.4219 6.30938 15.4219 6.69375C15.4219 7.07812 15.7406 7.3875 16.1297 7.3875H20.0531L13.5844 14.0531L9.55781 10.1109C9.42188 9.97969 9.24844 9.90937 9.05625 9.90937C8.86875 9.90937 8.69063 9.97969 8.55469 10.1109L1.69688 16.8188C1.60781 16.9078 1.5 17.0625 1.5 17.3203C1.5 17.5125 1.56563 17.6719 1.69688 17.7984C1.83281 17.9297 2.00625 18 2.19844 18C2.38594 18 2.56406 17.9297 2.7 17.7984L9.05625 11.5781L13.0828 15.5203C13.2188 15.6516 13.3922 15.7219 13.5844 15.7219C13.7719 15.7219 13.95 15.6516 14.0859 15.5203L21.0891 8.4V12.2297C21.0891 12.6094 21.4078 12.9234 21.7969 12.9234C22.1859 12.9234 22.5047 12.6141 22.5047 12.2297V6.69375C22.5 6.30938 22.1812 6 21.7922 6Z"
    />
  </Icon>
);

export default IconTrendingUp;
